'use client';

interface MenuLogoProps {
    className?: string;
}

export default function MenuLogo({ className = '' }: MenuLogoProps) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            enableBackground="new 0 0 2834.646 2834.646"
            version="1.1"
            xmlSpace="preserve"
            viewBox="1286.5 297.88 257.88 1729.5"
        >
            <title>Comedy Club Haug</title>
            <g transform="translate(115 -592.19)">
                <path
                    d="m1268.2 2503c-4.245 13.69-15.28 21.86-29.182 21.86-8.164 0.226-16.025-3.104-21.542-9.126-5.44-5.72-8.448-13.329-8.389-21.223-7e-3 -7.849 3.126-15.374 8.7-20.9 5.45-5.779 13.07-9.011 21.013-8.914 14.324 0 24.831 7.852 29.394 22.285h-17.716c-2.334-3.926-6.26-6.049-11.778-6.049-7.536 0-13.052 5.731-13.052 13.583 0 8.7 5.517 14.114 13.583 14.114 4.386 0.081 8.524-2.028 11.035-5.625l17.934-5e-3z"
                    fill="currentColor"
                />
                <rect x="1277.6" y="890.09" width="16.66" height="1633.3" fill="currentColor" />
                <path
                    d="m1356.7 2466.4v56.985h-15.6v-7.641c-3.61 5.941-9.02 8.7-16.344 8.7-11.778 0-19.525-7.428-19.525-20.48v-37.564h16.874v30.88c0 7.958 1.7 11.568 8.171 11.568 6.58 0 9.976-3.928 9.976-11.568v-30.88h16.448z"
                    fill="currentColor"
                />
                <path
                    d="m1384.7 2523.4h-16.235v-1633.3h16.872v1582.7c3.5-4.563 8.7-7.215 15.917-7.215 7.132-0.049 13.983 2.782 19 7.852 11.827 11.355 12.21 30.148 0.855 41.975-0.546 0.569-1.115 1.115-1.704 1.639-4.876 4.415-11.251 6.805-17.828 6.684-6.791 0-11.885-1.8-16.872-6.684l-5e-3 6.366zm13.16-14.855c8.6 0 14.751-6.049 14.751-14.008-0.047-7.817-6.403-14.125-14.22-14.114-7.852 0-13.8 6.156-13.8 14.326-0.189 7.431 5.683 13.609 13.114 13.797 0.05 1e-3 0.1 2e-3 0.151 3e-3"
                    fill="currentColor"
                />
                <path
                    d="m1171.5 2596.6v-1706.3l16.254-0.233v1656.4c3.5-5.519 9.565-8.171 16.781-8.171 11.781 0 19.42 7.428 19.42 20.48v37.565h-16.766v-30.879c0-7.96-1.7-11.568-8.171-11.568-6.58 0-10.839 3.926-10.839 11.568v30.879l-16.679 0.231z"
                    fill="currentColor"
                />
                <path
                    d="m1277.8 2590c-4.988 4.882-10.08 6.684-16.872 6.684-6.577 0.121-12.952-2.269-17.828-6.684-12.261-10.885-13.378-29.648-2.493-41.91 0.524-0.59 1.071-1.159 1.64-1.705 5.017-5.07 11.868-7.901 19-7.852 6.9 0 12.2 2.334 16.023 7.215v-6.368h16.766v56.985h-16.236v-6.365zm-13.158-8.489c7.433-0.105 13.373-6.216 13.268-13.649-1e-3 -0.05-2e-3 -0.101-3e-3 -0.151 0-8.171-6.047-14.326-13.9-14.326-7.792-3e-3 -14.111 6.311-14.114 14.102v0.012c0 7.958 6.156 14.008 14.751 14.008"
                    fill="currentColor"
                />
                <path
                    d="m1357.2 2539.4v56.985h-15.6v-7.64c-3.61 5.941-9.02 8.7-16.344 8.7-11.778 0-19.525-7.428-19.525-20.48v-37.565h16.877v30.881c0 7.958 1.7 11.568 8.171 11.568 6.58 0 9.976-3.928 9.976-11.568v-30.881h16.445z"
                    fill="currentColor"
                />
                <path
                    d="m1394.1 2595.8c-15.28 0-26.846-12.524-26.846-29.078-0.101-7.962 3.039-15.623 8.7-21.223 4.737-5.027 11.344-7.869 18.251-7.852 6.58 0 11.674 2.44 15.388 7.215v-6.366h16.129v51.149c0 7.534 0 13.583-4.457 19.42-5.412 7-13.477 10.5-24.088 10.5-15.07 0-25.468-7.64-27.591-19.525h18.677c1.06 3.608 4.457 5.835 9.445 5.835 7.428 0 11.885-4.776 11.885-13.477 0.018-0.956-0.018-1.913-0.106-2.865-4.669 4.245-9.445 6.262-15.388 6.262m2.867-14.964c7.428 0 13.265-6.049 13.265-14.008 0-8.277-6.049-14.22-12.84-14.22-7.595-0.198-13.913 5.798-14.112 13.393-5e-3 0.205-6e-3 0.41-2e-3 0.615 0 7.958 6.047 14.22 13.689 14.22"
                    fill="currentColor"
                />
            </g>
        </svg>
    );
}
